export async function getAvailableSpeakerDevices() {
  const availableDevices = await navigator.mediaDevices.enumerateDevices();

  return availableDevices
    .filter(d => d.kind === "audiooutput")
    .map(d => ({value: d.deviceId, label: d.label || `Audio Output (${d.deviceId.substring(0, 9)})`}));
}